export function orderReducer(state = {
    WAITING:{},
    VALIDATE:{},
    SHIPPED:{},
    DELIVERED:{},
}, {
    type,
    payload
}){
    switch(type){
        case "GET_ORDERS":
            let status = Object.assign({}, state)
            
            Object.values(payload).forEach( order  => {
                if (!status[order.order_status]) {
                    status[order.order_status] = {}
                }
                status[order.order_status][order.order_id] = order
            })
                
            return status;

        case "UPDATE_ORDER":
            let list = Object.assign({}, state)
            list[payload.order_status][payload.order_id] = payload
            return list;

        default:
            return state;
    }
}